(function () {
  const adultSizeOrder = ["XS", "S", "M", "L", "XL", "XXL", "3XL"];
  const kidsAlphaSizeOrder = ["XS", "S", "M", "L", "XL", "XXL"];
  const kidsNumericSizeOrder = ["16", "18", "20", "22", "24", "26", "28"];

  function clamp(number, min, max) {
    return Math.max(min, Math.min(max, number));
  }

  function confidenceFromDistance(distance) {
    const cleanDistance = clamp(Number(distance) || 0, 0, 0.5);
    const confidence = Math.round(clamp(94 - cleanDistance * 18, 84, 96));
    const secondConfidence = Math.round(clamp(76 + cleanDistance * 14, 68, confidence - 7));

    return { confidence, secondConfidence };
  }

  function confidenceFromRangeScore(score) {
    const cleanScore = Math.max(0, Number(score) || 0);
    const confidence = Math.round(clamp(94 - cleanScore * 10, 78, 95));
    const gap = Math.round(clamp(10 + cleanScore * 4, 10, 24));
    const secondConfidence = Math.round(clamp(confidence - gap, 62, confidence - 7));

    return { confidence, secondConfidence };
  }

  function normalizeSize(value) {
    return String(value || "")
      .toUpperCase()
      .trim()
      .replace(/\s+/g, "")
      .replace(/^2XL$/, "XXL")
      .replace(/^XXXL$/, "3XL")
      .replace(/^3XL\+$/, "3XL");
  }

  function rawVariantValues(variant) {
    const values = [];
    if (variant && variant.title) values.push(variant.title);
    if (variant && Array.isArray(variant.options)) values.push(...variant.options);
    return values.filter((value) => value !== null && value !== undefined);
  }

  function variantSize(variant, fitType, sizeOrder) {
    const values = rawVariantValues(variant);
    const normalizedValues = values.map(normalizeSize);
    const order = Array.isArray(sizeOrder) && sizeOrder.length ? sizeOrder : adultSizeOrder;

    for (let index = order.length - 1; index >= 0; index -= 1) {
      const wanted = normalizeSize(order[index]);
      if (normalizedValues.includes(wanted)) return order[index];
    }

    if (fitType === "kids") {
      for (let index = kidsNumericSizeOrder.length - 1; index >= 0; index -= 1) {
        const wanted = kidsNumericSizeOrder[index];
        const pattern = new RegExp(`(?:^|[^0-9])(?:SIZE)?${wanted}(?:$|[^0-9])`, "i");
        if (values.some((value) => pattern.test(String(value)))) return wanted;
      }
    }

    const joined = normalizedValues.join("|");
    if (/(^|\|)3XL(\+)?($|\|)/.test(joined)) return "3XL";
    if (/(^|\|)(XXL|2XL)($|\|)/.test(joined)) return "XXL";
    if (/(^|\|)XL($|\|)/.test(joined)) return "XL";
    if (/(^|\|)L($|\|)/.test(joined)) return "L";
    if (/(^|\|)M($|\|)/.test(joined)) return "M";
    if (/(^|\|)S($|\|)/.test(joined)) return "S";
    if (/(^|\|)XS($|\|)/.test(joined)) return "XS";

    return "";
  }

  const fitProfiles = {
    shirt: {
      label: "חולצת כדורגל",
      note: "ענה על כמה שאלות קצרות ונחשב לך המלצת מידה לחולצת כדורגל.",
      subtitle: "החישוב מבוסס על גובה, משקל והעדפת גזרה. ההמלצה מיועדת לחולצות כדורגל בלבד.",
      question: "איך אתה אוהב שהחולצה יושבת?",
      guide: "בחולצות כדורגל, מי שאוהב יותר מרווח בדרך כלל יעדיף לעלות מידה.",
      stepThreeNote: "כמעט סיימנו. עכשיו נשאר לבחור איך אתה אוהב שהחולצה יושבת.",
      resultCopy: "בחולצת כדורגל"
    },
    jacket: {
      label: "ג׳קט",
      note: "ענה על כמה שאלות קצרות ונחשב לך המלצת מידה לג׳קט.",
      subtitle: "החישוב מבוסס על גובה, משקל והעדפת גזרה, לפי טבלת המידות של הג׳קטים.",
      question: "איך אתה אוהב שהג׳קט יושב?",
      guide: "בג׳קטים, אם אתה מתכנן ללבוש שכבה מתחת או אוהב יותר מרווח, בדרך כלל עדיף לבחור גזרה רחבה יותר.",
      stepThreeNote: "כמעט סיימנו. עכשיו נשאר לבחור איך אתה אוהב שהג׳קט יושב.",
      resultCopy: "בג׳קט"
    },
    kids: {
      label: "חולצת ילדים",
      note: "ענה על כמה שאלות קצרות ונחשב לכם המלצת מידה לחולצת ילדים.",
      subtitle: "החישוב מבוסס בעיקר על גובה וגיל, ובנוסף על משקל והעדפת גזרה, לפי טבלת מידות הילדים.",
      question: "איך תרצו שהחולצה תשב?",
      guide: "במידות ילדים, אם נמצאים בין שתי מידות או רוצים מקום לגדילה, בדרך כלל עדיף לבחור אפשרות מרווחת יותר.",
      stepThreeNote: "כמעט סיימנו. עכשיו נשאר לבחור איך תרצו שהחולצה תשב.",
      resultCopy: "בחולצת הילדים"
    }
  };

  const jacketRanges = [
    { size: "S", height: [165, 170], weight: [45, 60] },
    { size: "M", height: [170, 175], weight: [60, 68] },
    { size: "L", height: [170, 175], weight: [68, 75] },
    { size: "XL", height: [175, 180], weight: [75, 82] },
    { size: "XXL", height: [180, 185], weight: [82, 95] }
  ];

  const kidsNumericRanges = [
    { size: "16", age: [2, 3], height: [90, 100], weight: [13, 18] },
    { size: "18", age: [4, 5], height: [100, 110], weight: [18, 23] },
    { size: "20", age: [5, 6], height: [110, 120], weight: [23, 28] },
    { size: "22", age: [7, 8], height: [120, 130], weight: [28, 33] },
    { size: "24", age: [8, 9], height: [130, 140], weight: [33, 38] },
    { size: "26", age: [10, 11], height: [140, 150], weight: [38, 43] },
    { size: "28", age: [12, 13], height: [150, 160], weight: [43, 48] }
  ];

  const kidsAlphaRanges = [
    { size: "XS", age: [4, 5], height: [100, 110], weight: [18, 23] },
    { size: "S", age: [5, 6], height: [110, 120], weight: [23, 28] },
    { size: "M", age: [7, 8], height: [120, 130], weight: [28, 33] },
    { size: "L", age: [8, 9], height: [130, 140], weight: [33, 38] },
    { size: "XL", age: [10, 11], height: [140, 150], weight: [38, 43] },
    { size: "XXL", age: [12, 13], height: [150, 160], weight: [43, 48] }
  ];

  function distanceToRange(value, range) {
    if (!Array.isArray(range)) return 0;
    if (value >= range[0] && value <= range[1]) return 0;
    if (value < range[0]) return range[0] - value;
    return value - range[1];
  }

  function estimateByRanges(height, weight, age, fitPreference, ranges, sizeOrder) {
    let best = ranges[0];
    let bestScore = Infinity;

    ranges.forEach((range) => {
      const heightScore = distanceToRange(height, range.height) / 4;
      const weightScore = distanceToRange(weight, range.weight) / 6;
      const middleWeight = (range.weight[0] + range.weight[1]) / 2;
      const tieBreaker = Math.abs(weight - middleWeight) / 60;
      const score = heightScore + weightScore + tieBreaker;

      if (score < bestScore) {
        bestScore = score;
        best = range;
      }
    });

    const order = sizeOrder || adultSizeOrder;
    let index = order.indexOf(best.size);

    if (fitPreference === "tight") index -= 1;
    if (fitPreference === "loose") index += 1;
    if (age >= 55 && fitPreference !== "tight") index += 0;

    index = clamp(index, 0, order.length - 1);

    let secondIndex = fitPreference === "tight" ? index + 1 : index - 1;
    if (secondIndex < 0 || secondIndex >= order.length || secondIndex === index) {
      secondIndex = clamp(index + 1, 0, order.length - 1);
    }

    const confidencePair = confidenceFromRangeScore(bestScore);

    return {
      size: order[index],
      confidence: confidencePair.confidence,
      secondSize: order[secondIndex],
      secondConfidence: confidencePair.secondConfidence
    };
  }

  function estimateKids(height, weight, age, fitPreference, ranges, sizeOrder) {
    let best = ranges[0];
    let bestScore = Infinity;

    ranges.forEach((range) => {
      const heightScore = distanceToRange(height, range.height) / 5;
      const ageScore = distanceToRange(age, range.age) / 1.5;
      const weightScore = distanceToRange(weight, range.weight) / 8;
      const score = heightScore * 1.65 + ageScore * 0.9 + weightScore * 0.65;

      if (score < bestScore) {
        bestScore = score;
        best = range;
      }
    });

    let index = sizeOrder.indexOf(best.size);
    if (fitPreference === "tight") index -= 1;
    if (fitPreference === "loose") index += 1;
    index = clamp(index, 0, sizeOrder.length - 1);

    let secondIndex = fitPreference === "tight" ? index + 1 : index - 1;
    if (secondIndex < 0 || secondIndex >= sizeOrder.length || secondIndex === index) {
      secondIndex = clamp(index + 1, 0, sizeOrder.length - 1);
    }

    const confidencePair = confidenceFromRangeScore(bestScore * 0.65);

    return {
      size: sizeOrder[index],
      confidence: confidencePair.confidence,
      secondSize: sizeOrder[secondIndex],
      secondConfidence: confidencePair.secondConfidence
    };
  }

  function hasNumericKidsSizes(productData) {
    const productValues = [productData.currentSize, productData.productTitle].filter(Boolean);
    const variantValues = (productData.variants || []).flatMap(rawVariantValues);

    return productValues.concat(variantValues).some((value) => {
      const text = String(value).trim().toUpperCase();
      return kidsNumericSizeOrder.some((size) => {
        if (text === size || text === `SIZE ${size}` || text === `SIZE${size}`) return true;
        return new RegExp(`(?:^|[^0-9])(?:SIZE\\s*)?${size}(?:$|[^0-9])`, "i").test(text);
      });
    });
  }

  function declaredProductSize(productData, fitType, sizeOrder) {
    const values = [productData.currentSize, productData.productTitle].filter(Boolean);

    for (let valueIndex = 0; valueIndex < values.length; valueIndex += 1) {
      const value = String(values[valueIndex]);
      const normalized = normalizeSize(value);

      for (let sizeIndex = sizeOrder.length - 1; sizeIndex >= 0; sizeIndex -= 1) {
        const size = sizeOrder[sizeIndex];
        const wanted = normalizeSize(size);
        if (normalized === wanted) return size;

        if (fitType === "kids" && kidsNumericSizeOrder.includes(size)) {
          const numericPattern = new RegExp(`(?:^|[^0-9])(?:SIZE\\s*)?${size}(?:$|[^0-9])`, "i");
          if (numericPattern.test(value)) return size;
        } else {
          const escaped = wanted.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
          const alphaPattern = new RegExp(`(?:^|[^A-Z0-9])${escaped}(?:$|[^A-Z0-9])`, "i");
          if (alphaPattern.test(value)) return size;
        }
      }
    }

    return "";
  }

  function getSizeOrder(fitType, productData) {
    if (fitType !== "kids") return adultSizeOrder;
    return hasNumericKidsSizes(productData || { variants: [] }) ? kidsNumericSizeOrder : kidsAlphaSizeOrder;
  }

  function estimateSize(height, weight, age, fitPreference, fitType, productData) {
    const sizeOrder = getSizeOrder(fitType, productData || { variants: [] });

    if (fitType === "jacket") {
      return estimateByRanges(height, weight, age, fitPreference, jacketRanges, adultSizeOrder);
    }

    if (fitType === "kids") {
      const ranges = sizeOrder === kidsNumericSizeOrder ? kidsNumericRanges : kidsAlphaRanges;
      return estimateKids(height, weight, age, fitPreference, ranges, sizeOrder);
    }

    let score = (weight - 52) / 11 + (height - 168) / 14;

    if (age >= 45) score += 0.12;
    if (age >= 60) score += 0.12;

    if (fitPreference === "tight") score -= 0.42;
    if (fitPreference === "loose") score += 0.48;

    const index = clamp(Math.round(score), 0, adultSizeOrder.length - 1);
    const exact = clamp(score, 0, adultSizeOrder.length - 1);
    const distance = Math.abs(exact - index);
    const confidencePair = confidenceFromDistance(distance);

    let secondIndex = exact > index ? index + 1 : index - 1;
    secondIndex = clamp(secondIndex, 0, adultSizeOrder.length - 1);

    if (secondIndex === index) {
      secondIndex = clamp(index + 1, 0, adultSizeOrder.length - 1);
    }

    return {
      size: adultSizeOrder[index],
      confidence: confidencePair.confidence,
      secondSize: adultSizeOrder[secondIndex],
      secondConfidence: confidencePair.secondConfidence
    };
  }

  function findVariantBySize(size, productData, fitType, sizeOrder) {
    const direct = (productData.variants || []).find((variant) => {
      return variant.available && variantSize(variant, fitType, sizeOrder) === size;
    }) || null;

    if (direct) return direct;

    const availableVariants = (productData.variants || []).filter((variant) => variant.available);
    const declared = declaredProductSize(productData, fitType, sizeOrder);
    if (availableVariants.length === 1 && declared === size) return availableVariants[0];

    return null;
  }

  function nearestAvailableSize(size, productData, fitType) {
    const sizeOrder = getSizeOrder(fitType, productData);
    const collectedSizes = (productData.variants || [])
      .filter((variant) => variant.available)
      .map((variant) => variantSize(variant, fitType, sizeOrder))
      .filter((variantSizeValue) => variantSizeValue && sizeOrder.includes(variantSizeValue));

    const availableVariants = (productData.variants || []).filter((variant) => variant.available);
    const declared = declaredProductSize(productData, fitType, sizeOrder);
    if (!collectedSizes.length && availableVariants.length === 1 && declared) collectedSizes.push(declared);

    const availableSizes = Array.from(new Set(collectedSizes));

    if (!availableSizes.length) {
      return { size, exact: false, variant: null };
    }

    if (availableSizes.includes(size)) {
      return {
        size,
        exact: true,
        variant: findVariantBySize(size, productData, fitType, sizeOrder)
      };
    }

    const wantedIndex = sizeOrder.indexOf(size);
    let best = availableSizes[0];
    let bestDistance = 99;

    availableSizes.forEach((availableSize) => {
      const distance = Math.abs(sizeOrder.indexOf(availableSize) - wantedIndex);
      if (distance < bestDistance) {
        bestDistance = distance;
        best = availableSize;
      }
    });

    return {
      size: best,
      exact: false,
      variant: findVariantBySize(best, productData, fitType, sizeOrder)
    };
  }

  function setStep(root, stepNumber) {
    root.querySelectorAll("[data-regista-fit-step]").forEach((step) => {
      step.classList.toggle("is-active", step.getAttribute("data-regista-fit-step") === String(stepNumber));
    });
  }

  function getProductData(root) {
    const script = root.querySelector("[data-regista-fit-product]");
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function renderBars(root, result) {
    const bars = root.querySelector("[data-regista-fit-bars]");
    if (!bars) return;

    bars.innerHTML = `
      <div class="regista-fit-bar">
        <div class="regista-fit-bar__head"><span>${result.size}</span><span>${result.confidence}%</span></div>
        <div class="regista-fit-bar__track"><div class="regista-fit-bar__fill" style="width:${result.confidence}%"></div></div>
      </div>
      <div class="regista-fit-bar regista-fit-bar--secondary">
        <div class="regista-fit-bar__head"><span>${result.secondSize}</span><span>${result.secondConfidence}%</span></div>
        <div class="regista-fit-bar__track"><div class="regista-fit-bar__fill" style="width:${result.secondConfidence}%"></div></div>
      </div>
    `;
  }

  function selectVariant(productData, variantId) {
    if (!productData || !variantId) return false;

    const form = document.getElementById(productData.formId);
    const picker = document.querySelector(`variant-picker[form="${CSS.escape(productData.formId)}"]`);

    if (picker && typeof picker.selectVariant === "function") {
      picker.selectVariant(Number(variantId));
      return true;
    }

    const masterInput = form ? form.querySelector('input[name="id"], select[name="id"]') : null;
    if (masterInput) {
      masterInput.disabled = false;
      masterInput.value = String(variantId);
      masterInput.dispatchEvent(new Event("change", { bubbles: true }));
      return true;
    }

    return false;
  }

  function inputIsValid(input) {
    const value = Number(input && input.value);
    const min = Number(input && input.getAttribute("min"));
    const max = Number(input && input.getAttribute("max"));
    if (!Number.isFinite(value)) return false;
    if (Number.isFinite(min) && value < min) return false;
    if (Number.isFinite(max) && value > max) return false;
    return true;
  }

  function initModal(modal) {
    if (modal.dataset.registaFitReady === "true") return;
    modal.dataset.registaFitReady = "true";

    const productData = getProductData(modal) || { variants: [] };
    const fitType = productData.fitType || "shirt";
    const profile = fitProfiles[fitType] || fitProfiles.shirt;

    const state = {
      height: 0,
      weight: 0,
      age: 0,
      fit: "regular",
      finalSize: "",
      finalVariantId: null
    };

    const heightInput = modal.querySelector("[data-regista-fit-height]");
    const weightInput = modal.querySelector("[data-regista-fit-weight]");
    const ageInput = modal.querySelector("[data-regista-fit-age]");
    const note = modal.querySelector("[data-regista-fit-note]");
    const subtitle = modal.querySelector("[data-regista-fit-subtitle]");
    const fitQuestion = modal.querySelector("[data-regista-fit-question]");
    const fitGuide = modal.querySelector("[data-regista-fit-guide]");

    if (note) note.textContent = profile.note;
    if (subtitle) subtitle.textContent = profile.subtitle;
    if (fitQuestion) fitQuestion.textContent = profile.question;
    if (fitGuide) fitGuide.textContent = profile.guide;

    function validateStepOne() {
      const button = modal.querySelector('[data-regista-fit-step="1"] [data-regista-fit-next]');
      if (button) button.disabled = !(inputIsValid(heightInput) && inputIsValid(weightInput));
    }

    function validateStepTwo() {
      const button = modal.querySelector('[data-regista-fit-step="2"] [data-regista-fit-next]');
      if (button) button.disabled = !inputIsValid(ageInput);
    }

    heightInput.addEventListener("input", validateStepOne);
    weightInput.addEventListener("input", validateStepOne);
    ageInput.addEventListener("input", validateStepTwo);

    modal.querySelectorAll("[data-regista-fit-next]").forEach((button) => {
      button.addEventListener("click", () => {
        const currentStep = button.closest("[data-regista-fit-step]").getAttribute("data-regista-fit-step");

        if (currentStep === "1") {
          state.height = Number(heightInput.value);
          state.weight = Number(weightInput.value);
          if (note) note.textContent = "כבר יש כיוון ראשוני. עוד שתי שאלות קצרות כדי לדייק את ההמלצה.";
          setStep(modal, 2);
        } else if (currentStep === "2") {
          state.age = Number(ageInput.value);
          if (note) note.textContent = profile.stepThreeNote;
          setStep(modal, 3);
        }
      });
    });

    modal.querySelectorAll("[data-regista-fit-back]").forEach((button) => {
      button.addEventListener("click", () => {
        const currentStep = Number(button.closest("[data-regista-fit-step]").getAttribute("data-regista-fit-step"));
        setStep(modal, Math.max(1, currentStep - 1));
      });
    });

    modal.querySelectorAll("[data-fit-pref]").forEach((button) => {
      button.addEventListener("click", () => {
        modal.querySelectorAll("[data-fit-pref]").forEach((item) => item.classList.remove("is-selected"));
        button.classList.add("is-selected");
        state.fit = button.getAttribute("data-fit-pref") || "regular";
      });
    });

    modal.querySelector("[data-regista-fit-calculate]").addEventListener("click", () => {
      const estimate = estimateSize(state.height, state.weight, state.age, state.fit, fitType, productData);
      const available = nearestAvailableSize(estimate.size, productData, fitType);
      const shownSize = available.size || estimate.size;
      const exact = available.exact;

      state.finalSize = shownSize;
      state.finalVariantId = available.variant ? available.variant.id : null;

      const title = modal.querySelector("[data-regista-fit-result-title]");
      const size = modal.querySelector("[data-regista-fit-size]");
      const copy = modal.querySelector("[data-regista-fit-result-copy]");
      const selectButton = modal.querySelector("[data-regista-fit-select-size]");

      title.textContent = exact ? "המידה המומלצת עבורך קיימת במלאי" : "זו המידה הקרובה ביותר שקיימת במלאי";
      size.textContent = shownSize;

      const finalResult = {
        size: shownSize,
        confidence: exact ? estimate.confidence : Math.max(76, estimate.confidence - 6),
        secondSize: estimate.secondSize === shownSize ? estimate.size : estimate.secondSize,
        secondConfidence: estimate.secondConfidence
      };

      renderBars(modal, finalResult);

      if (exact) {
        copy.innerHTML = `לפי הגובה, המשקל, הגיל והעדפת הגזרה שבחרתם, יש סיכוי גבוה שמידה <strong>${shownSize}</strong> תהיה הבחירה הנוחה ${profile.resultCopy}.`;
      } else {
        copy.innerHTML = `לפי הנתונים ההמלצה הראשונית היא <strong>${estimate.size}</strong>, אבל היא לא זמינה כרגע במוצר הזה. המידה הקרובה ביותר במלאי היא <strong>${shownSize}</strong>.`;
      }

      selectButton.textContent = state.finalVariantId ? `בחר מידה ${shownSize}` : "המידה לא זמינה כרגע";
      selectButton.disabled = !state.finalVariantId;
      // Redesign: lets the CSS grey the size badge when no variant of the recommended size can be selected.
      const pill = modal.querySelector(".regista-fit-result-pill");
      if (pill) pill.classList.toggle("is-unavailable", !state.finalVariantId);

      if (note) note.textContent = "ההמלצה נשארת אצלך בדפדפן בלבד. אנחנו לא שומרים את הנתונים האלה.";
      setStep(modal, 4);
    });

    modal.querySelector("[data-regista-fit-select-size]").addEventListener("click", () => {
      if (selectVariant(productData, state.finalVariantId)) {
        closeModal(modal);
      }
    });

    modal.querySelector("[data-regista-fit-restart]").addEventListener("click", () => {
      if (note) note.textContent = profile.note;
      setStep(modal, 1);
    });
  }

  function openModal(modal) {
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    initModal(modal);
    if (!modal.classList.contains("is-open")) {
      modal.__registaReturnFocus = document.activeElement;
      modal.__registaBodyOverflow = document.body.style.overflow;
      modal.__registaHtmlOverflow = document.documentElement.style.overflow;
    }
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("regista-fit-modal-open");
    document.body.classList.add("regista-fit-modal-open");
    document.body.style.overflow = "hidden";
    setStep(modal, 1);
    window.setTimeout(() => {
      const first = modal.querySelector("[data-regista-fit-close], button, input, select, [tabindex]:not([tabindex='-1'])");
      if (first && typeof first.focus === "function") first.focus();
    }, 20);
  }

  function closeModal(modal) {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("regista-fit-modal-open");
    document.body.classList.remove("regista-fit-modal-open");
    document.body.style.overflow = modal.__registaBodyOverflow || "";
    document.documentElement.style.overflow = modal.__registaHtmlOverflow || "";
    const returnFocus = modal.__registaReturnFocus;
    modal.__registaReturnFocus = null;
    if (returnFocus && typeof returnFocus.focus === "function") returnFocus.focus();
  }

  document.addEventListener("click", (event) => {
    const openButton = event.target.closest("[data-regista-fit-open]");
    if (openButton) {
      const container = openButton.closest(".product-info, .quick-buy, body");
      const modal = (container && container.querySelector("[data-regista-fit-modal]")) || document.querySelector("[data-regista-fit-modal]");
      if (modal) openModal(modal);
      return;
    }

    const closeButton = event.target.closest("[data-regista-fit-close]");
    if (closeButton) {
      const modal = closeButton.closest("[data-regista-fit-modal]");
      if (modal) closeModal(modal);
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    document.querySelectorAll("[data-regista-fit-modal].is-open").forEach(closeModal);
  });
})();
